(function($, window, document, undefined) {
	// https://stackoverflow.com/questions/37033406/automatically-open-details-element-on-id-call

	function openTarget() {
		var hash = location.hash.substring(1);
		if (hash) var details = document.getElementById(hash);
		if (
			details &&
			details.tagName.toLowerCase() === "details" &&
			details.classList.contains("js-details-anchor")
		)
			details.open = true;
	}

	$(function() {
		window.addEventListener("hashchange", openTarget);
		openTarget();
	});
})(jQuery, window, document);
